import {
  OreButton,
  OreCardContainer,
  OreCardWrapper,
  OreHeading,
  OreStack,
  OreText,
} from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useAccountingStatus } from '@/Contract/ui/context'
import { productContractingTranslation } from '@/Contract/ui/contractTranslation'
import PromotionalBannerBackground from '@/Shared/ui/assets/Promotional-Banner.jpg'
import { navigationRoutes } from '@/Shared/ui/routers'
import { useUserData } from '@/User/ui/context'

interface ProductsContractingBannerProps {
  origin: string
}

export const ProductsContractingBanner = ({
  origin,
}: ProductsContractingBannerProps): JSX.Element | null => {
  const { t } = useTranslation()
  const navigation = useNavigate()
  const { accountingStatus } = useAccountingStatus()
  const {
    hirableInfo: { hasHirableProducts, canBeHiredOnline },
  } = useUserData()


  const handleButtonClick = (): void => {
    navigation(navigationRoutes.contractNewProducts, { state: { origin } })
  }

  if (accountingStatus.debtAmount !== 0) return null
  if (!hasHirableProducts) return null

  return (
    <OreCardContainer>
      <div
        style={{
          backgroundImage: `url("${PromotionalBannerBackground}")`,
          backgroundSize: 'cover',
        }}
      >
        <OreCardWrapper space={canBeHiredOnline ? 'large' : 'small'}>
          <OreStack direction="row" placeContent="space-between" placeItems="center">
            <OreStack direction="column" placeItems="start" space="2xsmall">
              <OreHeading size={'headline-lg'} tone="white">
                {t(
                  productContractingTranslation.banner[
                    canBeHiredOnline ? 'active' : 'inactive'
                  ].title,
                )}
              </OreHeading>
              {canBeHiredOnline ? null : (
                <div style={{ maxWidth: '535px' }}>
                  <OreText size="text-md" tone="white">
                    {t(productContractingTranslation.banner.inactive.subtitle)}
                  </OreText>
                </div>
              )}
            </OreStack>
            {/* <OreButton
              onClick={() => {
                window.open(
                  'https://www.edenred.es/ticket-restaurant/restaurantes/premium',
                  '_blank',
                )
              }}
              target="_blank"
              category="primary"
              data-testid={'contractProducts'}
            >
              {t(productContractingTranslation.banner.active.cta.label)}
            </OreButton> */}
            <OreStack direction="column" placeItems="start" space="2xsmall">
              {canBeHiredOnline ? (
                <OreButton
                  onClick={handleButtonClick}
                  category="primary"
                  data-testid={'contractProducts'}
                >
                  {t(productContractingTranslation.banner.active.cta.label)}
                </OreButton>
              ) : null}
            </OreStack>
          </OreStack>
        </OreCardWrapper>
      </div>
    </OreCardContainer>
  )
}
